/**
 * @typedef {string} sortTypes
 */

/**
 * @enum {sortTypes}
 */
export var sortTypes = {
  CATEGORY: 'CATEGORY',
  VALUE: 'VALUE',
  DATE: 'DATE',
  SUM_OF_SERIES: 'SUM_OF_SERIES',
  FIRST_SERIES: 'FIRST_SERIES',
  SORT_ORDER: 'SORT_ORDER',
  UNKNOWN: 'UNKNOWN'

};